import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
Vue.use(Router);

import chart from './chart';
import provider from './provider';
import report from './report';
import vendor from './vendor';
import cashin from './cash-in';
import admin_tools from './admin-tools';
import partner from './partner';

var router = new Router({
  // mode: "history",
  routes: [
    //Main
    {
      path: '/test',
      component: () => import('@/components/Test'),
      meta: {
        title: 'Dashboard',
        breadcrumb: [
          {
            text: '<i class="ti-home"></i> Dashboard 1',
            href: '/'
          }
        ]
      }
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/components/Errors/E403')
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/components/Dashboard'),
      meta: {
        can: 'admin::dashboard'
      }
    },
    {
      path: '/main/users',
      name: 'main/users',
      component: () => import('@/components/Main/Users'),
      meta: {
        can: 'admin::customer:list'
      }
    },
    {
      path: '/user/kyc',
      name: 'user/kyc',
      component: () => import('@/components/Main/Kyc'),
      props: {
        Request: true,
        Rejected: false,
        Verified: false
      },
      meta: {
        can: 'admin::customer:kyc'
      }
    },
    {
      path: '/user/kyc-verified',
      name: 'user/kyc-verified',
      component: () => import('@/components/Main/Kyc'),
      props: {
        Verified: true,
        Rejected: false,
        Request: false
      },
      meta: {
        can: 'admin::customer:kyc-verified'
      }
    },
    ,
    {
      path: '/user/kyc-rejected',
      name: 'user/kyc-rejected',
      component: () => import('@/components/Main/Kyc'),
      props: {
        Rejected: true,
        Verified: false,
        Request: false
      },
      meta: {
        can: 'admin::customer:kyc-rejected'
      }
    },
    //Provider
    provider,
    //Reports
    report,
    //Vendors
    vendor,
    //CashIn
    cashin,
    //Charts
    chart,
    //Admin Tools
    admin_tools,
    //Partner
    partner,
    {
      name: 'login',
      path: '/login',
      component: () => import('@/components/Login')
    },
    {
      path: '/login/activate',
      name: 'login-activate',
      component: () => import('@/components/Login'),
      props: route => ({
        Login: route.params.Login,
        Password: route.params.Password,
        Secret: route.params.Secret,
        Message: route.params.Message
      })
    },
    {
      name: 'login-confirm',
      path: '/login/confirm',
      component: () => import('@/components/Login'),
      props: true
    },
    //Notifications
    {
      path: '/notification/notifications',
      component: () => import('@/components/Notifications/Notifications')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/login/activate', '/login/confirm'];
  const authRequired = !publicPages.includes(to.path);
  store.dispatch('checkAuth').then(() => {
    const authenticated = store.state.authenticated;
    if (authRequired && !authenticated) {
      return next('/login');
    }
    next();
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js